import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import ACCentralDetail from '../../components/ac_central/ACCentralDetail';
import { defaultRejectHandler } from '../../utils/utility';
import {
  getACCentral,
  createACCentral,
  clearTobeCreatedACCENTRAL,
} from '../../redux/ac_central/ac_central_actions';

class ACCentralCreateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.acDetail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.ac !== nextProps.ac && nextProps.show) {
      this.props.getAC(nextProps.ac.id);
    }
    if (this.props.show && nextProps.show !== this.props.show) {
      this.props.clearAC();
    }
  }

  onSaveHandler() {
    const newAC = this.acDetail.getWrappedInstance().getWrappedInstance().getACData();
    newAC['water_pump_list'] = this.props.ToBeCreatedACCentral.water_pump_list.map((each_water_pump)=>{
      return {
        "water_pump_id": each_water_pump.water_pump.id, 
        "quantity": each_water_pump.quantity
      }
    });

    newAC['chiller_list'] = this.props.ToBeCreatedACCentral.chiller_list.map((each_chiller)=>{
      return {
        "chiller_id": each_chiller.chiller.id, 
        "quantity": each_chiller.quantity
      }
    });

    newAC['cooling_tower_list'] = this.props.ToBeCreatedACCentral.cooling_tower_list.map((each_cooling_tower)=>{
      return {
        "cooling_tower_id": each_cooling_tower.cooling_tower.id, 
        "quantity": each_cooling_tower.quantity
      }
    });

    newAC['fan_coil_list'] = this.props.ToBeCreatedACCentral.fan_coil_list.map((each_fan_coil)=>{
      return {
        "fan_coil_id": each_fan_coil.fan_coil.id
      }
    });

    this.props.createAC(newAC);
  }

  render() {
    const { isCreating, errorMessage, ToBeCreatedACCentral, t, getAC, createAC, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create a/c central')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ACCentralDetail
            ac={ToBeCreatedACCentral}
            ref={ref => (this.acDetail = ref)}
            mode={'create'}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-central-unit-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.ac.central.errorMessage,
  isCreating: state.ac.central.isCreating,
  ToBeCreatedACCentral: {
    water_pump_list: state.ac.central.ToBeCreatedWaterPump,
    chiller_list: state.ac.central.ToBeCreatedChiller,
    cooling_tower_list: state.ac.central.ToBeCreatedCoolingTower,
    fan_coil_list: state.ac.central.ToBeCreatedAirHandlingUnit,
  }
});

const mapDispatchToProps = dispatch => ({
  createAC: ac => defaultRejectHandler(dispatch(createACCentral(ac.name, ac.description, ac.image, ac.water_pump_list, ac.chiller_list, ac.cooling_tower_list, ac.fan_coil_list))),
  getAC: id => defaultRejectHandler(dispatch(getACCentral(id))),
  clearAC: () => defaultRejectHandler(dispatch(clearTobeCreatedACCENTRAL()))
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ACCentralCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_central/ACCentralCreateModal.js